import React from 'react';
import QueriesTable from '../../../components/queries-table/QueriesTable'
import { useGetCurrentUserQuery } from '../../../store/user/userApi';
import { useTheme } from '../../../theme-context';
import { useNavigate } from 'react-router-dom';

const Queries = () => {
	const {data: user} = useGetCurrentUserQuery();
	console.log({user});
	const { theme } = useTheme();
		const navigate = useNavigate();
		const onClickGoBack = () => {
			navigate('/insights');
		};
	return (
		<div className="">
			<div
                className="flex flex-row items-center cursor-pointer hover:opacity-80 mt-3 mb-8"
                onClick={onClickGoBack}>
                <img
                    src={
                        theme === 'dark'
                            ? '/assets/shared/arrow-back-white.svg'
                            : '/assets/shared/arrow-back.svg'
                    }
                    className={'object-contain w-[20px] mr-2'}
                />
                <p className="dark:text-primary-dark">Show Queries and Feedbacks</p>
            </div>
			{user?.id && <QueriesTable hotelId={user?.id} />}
		</div>
	)
}

export default Queries;